import Vue from 'vue'
import ChatBall from './ChatBall.vue'
import { useChatBall } from './useChatBall.js'

const chatBall = {
  ball: null,
  show() {
    if (!this.ball) {
      const ChatBallConstructor = Vue.extend(ChatBall)
      const ins = new ChatBallConstructor(ChatBallConstructor)
      this.ball = ins.$mount()
      document.body.appendChild(this.ball.$el)
    } else {
      this.ball.timeToHide()
    }

    useChatBall().toggleVisible(true)
  },

  hide() {
    useChatBall().toggleVisible(false)
  },

  levelUp() {
    if (!this.ball) return
    this.ball.$el.classList?.add('level-up')
  },
  levelDown() {
    if (!this.ball) return
    this.ball.$el.classList?.remove('level-up')
  }
}

export default chatBall
